import React, { useState } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import chevronPrimaryRoundedIcon from '@/assets/icons/chevron-rounded-primary-down.svg';

interface ECData {
  description?: string;
  ecmev?: number;
  ecmev_alert_threshold?: number;
}

interface ECGeneralInfoAccordionProps {
  ecData: ECData;
}

const ECGeneralInfoAccordion: React.FC<ECGeneralInfoAccordionProps> = ({ ecData }) => {
  const [isOpen, setIsOpen] = useState(true);
  const dataItems = [
    {
      label: 'Description',
      value: ecData.description || 'No description provided'
    },
    {
      label: 'ECMEV',
      value: `€${(ecData.ecmev || 0).toLocaleString()} (100% of BMEV)`
    },
    {
      label: 'ECMEV Alerting Threshold',
      value: `${ecData.ecmev_alert_threshold || 0}%`
    }
  ];

  return (
    <Accordion
      defaultValue="item-1"
      type="single"
      collapsible
      className="mt-3"
      onValueChange={(value) => setIsOpen(value === 'item-1')}
    >
      <AccordionItem value="item-1" className="bg-lightPurple rounded-[16px] overflow-hidden">
        <AccordionTrigger
          icon={<img src={chevronPrimaryRoundedIcon} alt="chevron icon" />}
          className={`py-0 min-h-[52px] px-4 ${isOpen ? 'border-b border-lightPurple-200' : ''}`}
        >
          <div>
            <p className="text-primary font-bold text-base">General Information</p>
          </div>
        </AccordionTrigger>
        <AccordionContent className="p-4 space-y-[1.1rem]">
          {dataItems.map((item, index) => (
            <div key={index}>
              <span className="text-[11px] text-lightPurple-300 font-medium">{item.label}</span>
              <p className="text-sm font-medium leading-[17px]">{item.value}</p>
            </div>
          ))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default ECGeneralInfoAccordion;
